export const translations = {
  originUf: {
    pt: 'UF de origem',
    en: 'Source UF',
    es: 'UF de origen',
    de: 'UF Ursprung',
  },
  originCity: {
    pt: 'Cidade de origem',
    en: 'Source city',
    es: 'Ciudad de origen',
    de: 'Ursprungsstadt',
  },
  destinationUf: {
    pt: 'UF de destino',
    en: 'Destination UF',
    es: 'UF de destino',
    de: 'UF Ziel',
  },
  destinationCity: {
    pt: 'Cidade de destino',
    en: 'Destination city',
    es: 'Ciudad de destino',
    de: 'Zielstadt',
  },
}